import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { openPopover } from '../../../actions/popover'
import ComposeExtraButton from './compose_extra_button'

const iconMap = {
  unlisted: 'unlock-filled',
  private: 'lock-filled',
  public: 'globe'
}

class StatusVisibilityButton extends React.PureComponent {
  setButton = ref => (this.button = ref)
  handleOnClick = () => this.props.onOpenPopover(this.button)
  render() {
    const { small, privacy } = this.props
    return (
      <ComposeExtraButton
        icon={iconMap[privacy]}
        title='Visibility'
        onClick={this.handleOnClick}
        small={small}
        buttonRef={this.setButton}
        iconClassName={_s.cIconComposeSensitive}
      />
    )
  }
}

const mapDispatchToProps = (dispatch, { onVisibility, privacy }) => ({
  onOpenPopover(targetRef) {
    dispatch(
      openPopover('STATUS_VISIBILITY', {
        targetRef,
        onVisibility,
        privacy
      })
    )
  }
})

StatusVisibilityButton.propTypes = {
  small: PropTypes.bool,
  onOpenPopover: PropTypes.func.isRequired,
  privacy: PropTypes.oneOf(['private', 'unlisted', 'public'])
}

export default connect(null, mapDispatchToProps)(StatusVisibilityButton)